import React, { useState } from "react";
import Headline5 from "../../components/headings/Headline5";
import Modal from "../../components/modal";
import { FormInput } from "../../wrappers/formInput";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import Button from "../../components/button";
import Datepicker from "../../components/datepicker";
import { DropDownInput } from '../../wrappers/selectInput';
import { Error } from "@progress/kendo-react-labels";
import { getMilliSecUTC } from "../../utils/EllowUtils";

export type HealthInsuranceForm = {
  nameIdProof: string;
  insuranceType: string;
}

interface Props {
  onClose?: any;
  clickHandler?: any;
  disabled?: any;
}

const validationSchema = Yup.object({
  nameIdProof: Yup.string().required("Field is required"),
  insuranceType: Yup.string().required("Field is required")
})

const HealthInsurancePurchaseModal: React.FC<Props> = ({ onClose, clickHandler, disabled}) => {
  const formOptions = {
    resolver: yupResolver(validationSchema),
  }

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState
  } = useForm<HealthInsuranceForm>(formOptions);
  
  const [error, setError] = useState<{dateOfBirth?: string}>({dateOfBirth: ''})

  const onSubmit = (data: any) => {
    
    let hasError: boolean = false

    if(data.dateOfBirth){
      data.dateOfBirth = getMilliSecUTC(data.dateOfBirth)
    }else{
      error.dateOfBirth = 'Field is required'
      hasError = true
    }
    if(!hasError) {  
      clickHandler(data)
    }
  }

  const changeOn = (e: any, name: any) => {
    
    setValue(name,e.target.value)    
    if (name === 'dateOfBirth'){
      delete error?.dateOfBirth   
      setError({...error})
    }
  }

  return (
    <Modal title={"Request Rating"} size="medium" onClose={onClose}>
      <form>
        <Headline5>Purchase health insurance</Headline5>
        <div className="half-form-wrap">
            <div className="form-group">
                <FormInput<HealthInsuranceForm>
                    name="nameIdProof"
                    label="Full Name(As per Govt.ID)"
                    placeholder="Name"
                    register={register}
                    type="text"
                    errors={formState.errors}
                />
            </div>
            <div className="form-group">
                <label className="lablel">Date of Birth</label>
                <Datepicker
                  defaultShow={false}
                  onChange={(e: any) => changeOn(e, 'dateOfBirth')}
                />  
                <Error>{error?.dateOfBirth}</Error>
            </div>
        </div>
        <div className="half-form-wrap">
            <DropDownInput<HealthInsuranceForm>
                data={['Individual','Family']}
                name="insuranceType"
                label="Type of health insurance"
                control={control}
                register={register}
                errors={formState.errors}
            />
        </div>
        <div className="popupAction">
            <Button variant="secondary" onClick={onClose}>Cancel</Button>
            <Button variant="primary" disabled={disabled} onClick={handleSubmit(onSubmit)}>Submit</Button>
        </div>
      </form>
    </Modal>
  )
}

export default HealthInsurancePurchaseModal;